export const ENUM_STATUS_ACTIVE = "Active";
export const ENUM_STATUS_ARCHIVED = "Archived";
export const ENUM_STATUS_PARENT_ARCHIVED = "ParentArchived";

export const ENUM_USER_TYPE_ORGANISATION_USER = "OrganisationUser";
export const ENUM_USER_TYPE_ORGANISATION_ADMIN = "OrganisationAdmin";
export const ENUM_USER_TYPE_MAGSTIM_ADMIN = "MagstimAdmin";

export const NOTE_TYPE_PATIENT = "Patient";
export const NOTE_TYPE_MEDICATION = "Medication";
export const NOTE_TYPE_DIAGNOSIS = "Diagnosis";
export const NOTE_TYPE_TREATMENT = "Treatment";
export const NOTE_TYPE_CLINICAL_ASSESSMENT = "ClinicalAssessment";

export const CLINICAL_ASSESSMENT_TYPE_MANUAL = "Manual";
export const CLINICAL_ASSESSMENT_TYPE_PATIENT_SELF_ASSESSMENT = "PatientSelfAssessment";
export const CLINICAL_ASSESSMENT_TYPE_USER_ASSESSMENT = "UserAssessment";

export const DATE_RANGE_ALL_TIME = "AllTime";
export const DATE_RANGE_LAST_4_WEEKS = "Last4Weeks";
export const DATE_RANGE_LAST_6_MONTHS = "Last6Months";
export const DATE_RANGE_LAST_YEAR = "LastYear";

export const REPORT_SECTION_RMT = "rMT";
export const REPORT_SECTION_ASSESSMENT = "Assessment";
export const REPORT_SECTION_TREATMENT = "Treatment";

